import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { Grid, Stack } from '@mui/material';
import { useState } from 'react';
import { FieldValues, SubmitHandler, useFormContext } from 'react-hook-form';
import { IDocument, uploadFileToS3 } from 'wisestep-api';
import {
  ControlledTextInput,
  WsButton,
  WsColors,
  WsFileUpload,
  WsSelect,
  WsTypoVariants,
  WsTypography,
} from 'wisestep-base';

import { downloadCV } from '../../../../features/conversationWidget/utils/cvHelper';

interface IAddEditNote {
  onSubmit: SubmitHandler<FieldValues>;
  onCancel: () => void;
}

const dropdownOptions = [
  { label: 'Phone', value: 'Phone' },
  { label: 'Email', value: 'Email' },
  { label: 'SMS', value: 'SMS' },
  { label: 'Other', value: 'Other' },
];

const AddEditNote = ({ onCancel, onSubmit }: IAddEditNote) => {
  const methods = useFormContext();
  const [otherDocument, setOtherDocument] = useState<IDocument[]>([]);

  const onUpload = async (file: File[], field: string) => {
    const url = await uploadFileToS3(file[0]);
    if (field === 'document') {
      const alteredDocuments = [...otherDocument];
      alteredDocuments.push({
        documentLocation: url,
        originalName: file[0].name,
        tag: null,
        uploadedOn: new Date(),
      });
      setOtherDocument([...alteredDocuments]);
    }
  };

  const removeDocHanlder = () => {
    setOtherDocument([]);
  };

  return (
    <form
      onSubmit={methods.handleSubmit((data) => {
        data.fileUrl = otherDocument?.[0]?.documentLocation?.split('?')?.[0];
        data.fileName = otherDocument?.[0]?.originalName;
        onSubmit(data);
      })}
    >
      <Stack spacing={1} mb={2}>
        <Grid container spacing={2} component="form">
          <Grid item xs={8} md={8}>
            <ControlledTextInput name="heading" fullWidth placeholder="Heading" />
          </Grid>

          <Grid item xs={4} md={4}>
            <WsSelect
              name="noteType"
              selectArray={dropdownOptions}
              defaultValue=""
              size="small"
              placeholder="Add Notes Type"
            />
          </Grid>
        </Grid>

        <ControlledTextInput
          name="description"
          multiline
          placeholder="Description"
          inputProps={{}}
          minRows={3}
        />
        <Stack direction="row" justifyContent="space-between">
          {otherDocument?.length > 0 ? (
            otherDocument?.map((document, index: number) => (
              <Stack key={index} direction="row" spacing={2} mb={2}>
                <WsTypography variant={WsTypoVariants.BODY1}>
                  {document?.originalName ?? ''}
                </WsTypography>
                <DownloadIcon
                  onClick={() =>
                    downloadCV(
                      document?.documentLocation?.split('?')[0] ?? '',
                      document?.originalName ?? ''
                    )
                  }
                  sx={{
                    color: WsColors.TheBlues500,
                    fontSize: '24px',
                    cursor: 'pointer',
                  }}
                />
                <CloseIcon
                  onClick={removeDocHanlder}
                  sx={{ color: WsColors.Red500, cursor: 'pointer' }}
                />
              </Stack>
            ))
          ) : (
            <WsFileUpload
              multiple={false}
              onUpload={(file: File[]) => onUpload && onUpload(file, 'document')}
              name={'document'}
              placeholderText=""
              bgRequired={false}
              buttonText={'Upload file'}
              maxFileSize={3}
            />
          )}
          <Stack direction="row" mt={1} spacing={2} justifyContent="flex-end">
            <WsButton variant="text" size="large" onClick={onCancel}>
              Cancel
            </WsButton>
            <WsButton size="large" type="submit">
              Save
            </WsButton>
          </Stack>
        </Stack>
      </Stack>
    </form>
  );
};

export default AddEditNote;
